import styled from "styled-components";

export const MainWrapper = styled.div`
  height: 7.125rem;
  width: ${props => (props.lang === "fr" ? "37.5rem" : "34.5rem")};
  border-radius: 1.5rem;
  background-color: ${props => props.theme.color.greyLight};
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 8%;
  z-index: 999999;
  display: flex;
  align-items: center;
`;
export const IconWrapper = styled.div``;
export const RemoteIcon = styled.div`
  width: 5rem;
  height: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const InfoWrapper = styled.div``;
export const TextWrapper = styled.div`
  color: ${props => props.theme.color.black};
  font-size: 1.75rem;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 1.875rem;
`;
export const DescriptionWrapper = styled.div`
  margin-top: 0.625rem;
  width: 80%;
  color: ${props => props.theme.color.black};
  font-size: 1.5rem;
  letter-spacing: 0;
  line-height: 1.75rem;
`;
